<template>
  <BasePage
    drawer
    :drawer-items="categories"
    @open-drawer="openNavDrawer"
    :active="active"
  >
    <v-spacer></v-spacer>

    <template #nav>
      <v-tabs
          center-active
          class="tab-digital-menu"
          :hide-slider="configs.enable_subcategories"
          v-model="parentCategorySelected">
        <v-tab
            class="text-overline rounded"
            :active-class="`${configs.enable_subcategories ? 'primary white--text' : ''}`"
            @click="!configs.enable_subcategories ? goToTab(`tab-${category.id}`) : ''"
            v-for="category in categories"
            :key="category.id"
            v-if="configs.enable_subcategories || category.products.length"
            :id="`#tab-${category.id}`"
        >
          {{ category.name }}
        </v-tab>
      </v-tabs>
    </template>

    <v-spacer></v-spacer>

    <v-tabs-items v-if="categories && configs.enable_subcategories" v-model="parentCategorySelected">
      <v-tab-item
          v-for="category in categories"
          :key="category.name"
      >
        <v-card v-if="category.children.length">
          <v-tabs
              center-active
              class="subcategory-tabs"
              height="35"
              v-model="categorySelected">
            <v-tab
                class="text-overline"
                style="font-size: 11px !important;"
                v-for="(subcategory, idx) in category.children"
                v-if="subcategory.products.length"
                @click="goToTab(`subcategory-tab-${subcategory.id_parent}_${subcategory.id}`)"
                :key="`${subcategory.name}_${subcategory.id}`"
            >
              {{ subcategory.name }}
            </v-tab>
          </v-tabs>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-container fluid class="px-1" :class="{'mt-8': hasChildren(), 'mb-12': hasRequests || totalItemsCart > 0}"
                 v-if="configs.enable_subcategories && categories && parentCategorySelected !== null">
      <div v-if="categories[parentCategorySelected].children.length">
        <div v-for="subcategory in categories[parentCategorySelected].children"
             v-show="subcategory.products.length"
             :id="`subcategory-tab-${subcategory.id_parent}_${subcategory.id}`"
             :key="`${subcategory.name}_${subcategory.id}`"
             class="mb-3 card-categories"
        >
          <span v-scroll="onScroll" :class="`subcategory-tab-${subcategory.id_parent}_${subcategory.id}`"
                :ref="`ref-${subcategory.id_parent}_${subcategory.id}`" class="text-overline primary--text">{{subcategory.name}}</span>

          <v-divider></v-divider>

          <card-product v-for="product in subcategory.products"
                        :key="product.id"
                        v-if="product.available_for_sale"
                        :show-image="configs.show_image"
                        @clicked="openInfoProduct = true; productSelected = product; animateCartIcon = false"
                        :product="product" />
        </div>

        <div v-if="categories[parentCategorySelected].products.length" class="mb-2">
          <span v-scroll="onScroll" :ref="`ref-${categories[parentCategorySelected].id}`" class="text-overline primary--text">{{categories[parentCategorySelected].name}}</span>

          <v-divider></v-divider>

          <card-product v-for="product in categories[parentCategorySelected].products"
                        :key="product.id"
                        v-if="product.available_for_sale"
                        :show-image="configs.show_image"
                        @clicked="openInfoProduct = true; productSelected = product; animateCartIcon = false"
                        :product="product" />
        </div>
      </div>

      <div v-else>
        <card-product v-for="product in categories[parentCategorySelected].products"
                      :key="product.id"
                      v-if="product.available_for_sale"
                      :show-image="configs.show_image"
                      @clicked="openInfoProduct = true; productSelected = product; animateCartIcon = false"
                      :product="product" />
      </div>
    </v-container>

    <v-container fluid v-else-if="categories" class="px-0">
      <div v-for="category in categories"
           :id="`tab-${category.id}`"
           :key="category.id"
           v-if="category.products.length"
           class="mb-7 card-categories">
        <span v-scroll="onScroll" :ref="`ref-${category.id}`" class="text-overline primary--text">{{category.name}}</span>

        <v-divider></v-divider>

        <card-product v-for="product in category.products"
                      :key="product.id"
                      v-if="product.available_for_sale"
                      :show-image="configs.show_image"
                      @clicked="openInfoProduct = true; productSelected = product; animateCartIcon = false"
                      :product="product" />
      </div>
    </v-container>

    <template #navDrawer>
      <v-navigation-drawer
          v-model="openDrawer"
          fixed
          left
          temporary
      >
        <v-list dense v-if="configs.enable_subcategories" v-model="parentCategorySelected">
          <v-subheader>Categorias</v-subheader>
          <div v-for="(item, i) in categories"
               :key="i"
          >
            <v-list-group
                :value="i === parentCategorySelected"
                v-if="item.children.length"
            >
              <template v-slot:activator>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </template>

              <v-list-item-group
                  v-model="categorySelected"
                  :value="i"
                  link
                  active-class="primary--text text--accent-4"
              >
                <v-list-item v-for="(subcategory, idx) in item.children"
                             @click="parentCategorySelected = i; goToTab(`subcategory-tab-${subcategory.id_parent}_${subcategory.id}`, idx); openNavDrawer()"
                             :value="idx"
                             :disabled="idx === categorySelected && parentCategorySelected === i"
                             class="ml-2"
                             v-show="subcategory.products.length"
                             :key="`${subcategory.name}_${subcategory.id}`"
                >
                  <v-list-item-title>{{ subcategory.name }}</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list-group>

            <v-list-item-group
                v-model="parentCategorySelected"
                v-else
                active-class="primary--text text--accent-4"
            >
              <v-list-item
                  :value="i"
                  :disabled="i === parentCategorySelected"
                  active-class="primary--text text--accent-4"
                  @click="openNavDrawer()"
              >
                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </div>
        </v-list>

        <v-list
            dense
            v-else
        >
          <v-subheader>Categorias</v-subheader>

          <v-list-item-group
              v-model="parentCategorySelected"
              link
              active-class="primary--text text--accent-4"
          >
            <v-list-item v-for="(item, i) in categories"
                         @click="goToTab(`tab-${item.id}`); openNavDrawer()"
                         :value="i"
                         :disabled="i === parentCategorySelected"
                         :key="i"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </template>

    <template #order>
      <v-card elevation="3" rounded="0"
              v-if="configs.enable_order && (totalItemsCart || hasRequests)"
              class="footer-cart secondary d-flex">
        <v-bottom-navigation
            absolute
            grow
            horizontal
            class="justify-space-around"
        >
          <v-btn class="justify-space-around" @click="openCart = true" v-if="totalItemsCart">
            <span class="font-weight-medium primary--text">
              Sacola
              <p class="font-weight-bold ma-0 mt-2" v-if="totalItemsCart">{{ formatMoney(state.total_value - state.tax_value) }}</p>
            </span>

            <v-badge overlap
                     bordered
                     color="primary"
                     :value="totalItemsCart"
                     :content="totalItemsCart">
              <v-icon color="primary" :class="{'shake' : animateCartIcon}">
                $cart
              </v-icon>
            </v-badge>
          </v-btn>

          <v-btn class="justify-space-around" v-if="hasRequests" @click="openRequests = true">
            <span class="font-weight-medium primary--text">
              Pedidos
            </span>

            <v-badge overlap
                     bordered
                     color="primary"
                     :value="hasRequests"
                     :content="hasRequests">
              <v-icon color="primary" :class="{'shake' : animateRequestIcon}">
                $noteTextOutline
              </v-icon>
            </v-badge>
          </v-btn>
        </v-bottom-navigation>
      </v-card>
    </template>

    <info-product @close="openInfoProduct = false; productSelected = null"
                  @productadded="onProductAdded()"
                  :dialog="openInfoProduct"
                  :configs="configs"
                  :product="productSelected" />

    <cart @close="openCart = false"
          @openRequests="openDialogRequests($event)"
          :dialog="openCart"
          :configs="configs" />

    <requests :dialog="openRequests"
              :error="errorRequests"
              @open-cart="openCart = true"
              @request-confirmed="animateRequestIcon = true"
              @close="openRequests = false; errorRequests = false" />

    <v-snackbar
        v-model="animateRequestIcon"
        class="mb-12"
    >
      <p class="px-2 ma-0">
        Houve alteração em seu(s) pedido(s).
      </p>
    </v-snackbar>
  </BasePage>
</template>

<script>
import BasePage from "./structure/BasePage";
import _ from "lodash"
import InfoProduct from "./DigitalMenu/InfoProduct";
import Cart from "./DigitalMenu/Cart";
import Requests from "./DigitalMenu/Requests";
import { useGlobalCart, useGlobalRequests } from '../../store/store'
import CardProduct from "./DigitalMenu/CardProduct.vue";

export default {
  name: 'DigitalMenu',
  components: {
    CardProduct,
    BasePage,
    InfoProduct,
    Cart,
    Requests
  },
  data: () => ({
    categories: null,
    parentCategorySelected: null,
    categorySelected: null,
    preventScroll: false,
    openDrawer: false,
    openInfoProduct: false,
    openCart: false,

    openRequests: false,
    errorRequests: false,

    productSelected: null,
    configs: {
      enable_order: false,
      show_decimal: false,
      show_image: false,
      show_price_symbol: false
    },
    active: true,

    animateCartIcon: false,
    animateRequestIcon: false
  }),
  setup() {
    const state = useGlobalCart()
    const requests = useGlobalRequests()

    return { state, requests }
  },
  mounted() {
    this.configs = _config.functionalities.digitalmenu.configs
    this.active = _config.functionalities.digitalmenu.active

    this.initCategories()
  },
  methods: {
    initCategories () {
      let allCategories = _.cloneDeep(this.getData('data'))

      if (this.configs.enable_subcategories) {
        let categories = allCategories.filter(category => !category.parent)

        allCategories.filter(category => category.parent).forEach(item => {
          //Verifica se o parent da subcategoria existe na listagem.
          let parentCategory = categories.find(category => category.id === item.parent.id);

          if (parentCategory) {
            // Se existir, adicione os produtos da subcategoria no children correspondente
            let children = parentCategory.children.find(c => c.id === item.id)
            children['id_parent'] = item.parent.id
            Object.assign(children, item)
          } else {
            let index = categories.push(item.parent)

            // Adiciono um array de products vazio no parent category apenas para não quebrar, pois em alguns casos
            // o parent também possue produtos além dos filhos
            categories[index - 1]['products'] = []

            let children = categories[index - 1].children.find(c => c.id === item.id)
            children['id_parent'] = item.parent.id
            Object.assign(children, item)
          }
        })

        categories.forEach(item => item.products.forEach(product => {
          if (product.available_for_sale && product.auto_description && product.attributes) {
            product.description = this.makeAttributesName(product.attributes)
          }

          if (product.children) {
            product.children.forEach(children => children.products.forEach(productChildren => {
                if (productChildren.available_for_sale && productChildren.auto_description && productChildren.attributes) {
                  productChildren.description = this.makeAttributesName(productChildren.attributes)
                }
              })
            )
          }
        }))

        //Filtra as subcategorias com produtos
        categories.forEach(category => {
          category.children = category.children.filter(children => children.products?.length)
        })

        this.categories = this.reorderCategories(categories).filter(category =>
            category.products.length > 0 || category.children.length > 0
        )
      } else {
        this.categories = allCategories.filter(category => category.products.length > 0)

        Array.from(this.categories).forEach(item => item.products.forEach(product => {
          if (product.available_for_sale && product.auto_description && product.attributes) {
            product.description = this.makeAttributesName(product.attributes)
          }
        }))
      }
    },

    reorderCategories (categories) {
      categories.forEach(category => {
        if (category.children.length) {
          category.children.sort((childrenA, childrenB) => childrenA.order - childrenB.order)
        }
      })

      return categories;
    },

    makeAttributesName(attributes) {
      return attributes.map(attribute => attribute.name + ` (${attribute.values.map(value => value.available_for_sale ? value.name : null).filter(value => value).join(', ')})`).join(', ')
    },

    goToTab(tab) {
      let offset = 100;

      if (tab.startsWith('subcategory-tab')) {
        offset = 145;
      }

      this.preventScroll = true

      setTimeout(() => {
        this.$vuetify.goTo('#' + tab, {duration: 0, offset, easing: 'easeInOutCubic'})

        this.$nextTick(() => {
          this.preventScroll = false
        })
      }, 350)
    },

    openNavDrawer() {
      this.openDrawer = !this.openDrawer
    },

    onScroll () {
      if (!this.preventScroll) {
        //Se tiver children e configuração de subcategoria estiver ativa
        if (this.hasChildren && this.configs.enable_subcategories) {
          Array.from(this.categories[this.parentCategorySelected].children).forEach((category, index) => {
            if (this.$refs['ref-' + `${category.id_parent}_${category.id}`][0].getBoundingClientRect().top <= 270) {
              this.categorySelected = index
            }
          });
        } else {
          Array.from(this.categories).forEach((category, index) => {
            if (this.$refs['ref-' + category.id] && this.$refs['ref-' + category.id][0].getBoundingClientRect().top <= 215) {
              this.parentCategorySelected = index
            }
          });
        }
      }
    },
    hasChildren () {
      return this.categories[this.parentCategorySelected].children.length
    },
    onProductAdded () {
      this.shakeCartIcon()

      if (!this.productSelected || !this.categories) return

      const productId = this.productSelected.id
      let nextCategoryId = null

      for (const category of this.categories) {
        if (category.products.some(p => p.id === productId)) {
          nextCategoryId = category.next_category_id
          break
        }
        if (category.children) {
          for (const child of category.children) {
            if (child.products?.some(p => p.id === productId)) {
              nextCategoryId = child.next_category_id
              break
            }
          }
          if (nextCategoryId) break
        }
      }

      if (!nextCategoryId) return

      const targetIndex = this.categories.findIndex(c => c.id === nextCategoryId)
      if (targetIndex !== -1) {
        this.parentCategorySelected = targetIndex
        if (!this.configs.enable_subcategories) {
          this.goToTab(`tab-${nextCategoryId}`)
        }
        return
      }

      if (this.configs.enable_subcategories) {
        for (let i = 0; i < this.categories.length; i++) {
          const childIndex = this.categories[i].children?.findIndex(c => c.id === nextCategoryId)
          if (childIndex !== undefined && childIndex !== -1) {
            this.parentCategorySelected = i
            this.$nextTick(() => {
              this.categorySelected = childIndex
              const child = this.categories[i].children[childIndex]
              this.goToTab(`subcategory-tab-${child.id_parent}_${child.id}`)
            })
            return
          }
        }
      }
    },

    shakeCartIcon () {
      this.animateCartIcon = true
    },
    openDialogRequests(event) {
      this.openRequests = true
      this.errorRequests = event
    }
  },
  computed: {
    totalItemsCart () {
      return _.sumBy(this.state.products, 'amount') + _.sumBy(this.state.combos, 'amount')
    },
    hasRequests () {
      return this.requests.requests.length
    }
  },
  watch: {
    parentCategorySelected (newV, oldV) {
      if (this.configs.enable_subcategories) {
        if (newV !== oldV) {
          this.$nextTick(() => {
            this.categorySelected = 0
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.tab-digital-menu .v-slide-group__prev {
  display: none !important;
}

.footer-cart {
  position: fixed;
  z-index: 3;
  bottom: 0;
  width: 100%;
  padding: 10px;
}

@mixin animation($str) {
  -webkit-animation: #{$str};
  -moz-animation: #{$str};
  -ms-animation: #{$str};
  -o-animation: #{$str};
  animation: #{$str};
}

@mixin keyframes($name){
  @-webkit-keyframes #{$name} {
    @content;
  }
  @-moz-keyframes #{$name} {
    @content;
  }
  @-ms-keyframes #{$name} {
    @content;
  }
  @-o-keyframes #{$name} {
    @content;
  }
  @keyframes #{$name} {
    @content;
  }
}

.shake {
  transform: translate3d(0, 0, 0);
  @include keyframes(shake){
    10%, 90% {
      transform: rotateZ(-6deg)
    }
    20%, 80% {
      transform: rotateZ(6deg)
    }
    30%, 50%, 70% {
      transform: rotateZ(-6deg)
    }
    40%, 60% {
      transform: rotateZ(6deg)
    }
  }

  @include animation('shake 0.98s cubic-bezier(.36,.07,.19,.97) 3');
}

.subcategory-tabs {
  position: fixed;
  right: 0;
  margin-top: 3px;
  z-index: 2
}

.v-slide-group__prev {
  display: none !important;
}
</style>